import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const leaveUserApi = factory.get("leaveUser");

const initialState = {
  searchBody: {},
  leave: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      start_date: dayjs().format("YYYY-MM-DD"),
      total_days: 1,
      reason: "",
    },
  },
  // The rep cancelling one of their own requests.
  cancel: {
    dialog: false,
    data: null,
  },
  leaves: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const leaveUserSlice = createSlice({
  name: "leaveUser",
  initialState,
  reducers: {
    setDialog: (state) => {
      state.leave.dialog = !state.leave.dialog;
    },
    setCancelDialog: (state, { payload }) => {
      state.cancel.dialog = !state.cancel.dialog;
      state.cancel.data = payload ?? null;
    },
    setDataTable: (state, { payload }) => {
      state.leaves.data = payload.data.data ?? [];
      state.leaves.total = payload.data.total ?? 0;
    },
    setById: (state, { payload }) => {
      state.leave.form.id = payload.id;
      state.leave.form.start_date = payload.start_date
        ? dayjs(payload.start_date).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD");
      state.leave.form.total_days = payload.total_days ?? 1;
      state.leave.form.reason = payload.reason ?? "";
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state) => {
      state.leave.form = initialState.leave.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setCancelDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
} = leaveUserSlice.actions;

export default leaveUserSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("leave"));
    const res = await leaveUserApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("leave"));
  } catch (err) {
    dispatch(setLoading("leave"));
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const create = (data, _SearchBody) => async (dispatch) => {
  try {
    await leaveUserApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة  بنجاح",
        type: "success",
      }),
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await leaveUserApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل  بنجاح",
        type: "success",
      }),
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const reject = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await leaveUserApi.reject(id, data);
    dispatch(
      showNotification({
        message: "تم الغاء الطلب بنجاح",
        type: "success",
      }),
    );
    dispatch(setCancelDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const LeaveUser = {
  getAll,
  create,
  update,
  reject,
};
